import { FaCheckCircle } from "react-icons/fa"; // For list item icons
import FooterComponent from "../../Components/Footer/FooterComponent";
import styles from "./LeadQualification.module.css";

const pageData = {
  sections: [
    {
      headline: "AI Sales Agent – Qualify Leads Instantly",
      subheadline:
        "Revolutionize your sales process with our AI-powered lead qualification system. Identify high-potential leads in seconds and close deals faster.",
      cta: "Start Qualifying Leads",
      items: [],
    },
    {
      headline: "Why Choose Our AI Sales Agent?",
      content:
        "Say goodbye to wasted time on unqualified prospects. Our AI delivers automated lead scoring, intelligent prioritization, and actionable insights to boost your sales pipeline.",
      items: [],
    },
    {
      headline: "How It Works",
      items: [
        "Import leads from CRM, spreadsheets, or marketing platforms.",
        "AI analyzes data in real-time with advanced algorithms.",
        "Scores and prioritizes leads based on intent and engagement.",
        "Get tailored follow-up recommendations.",
        "Focus on high-value leads while AI handles the rest.",
      ],
      content:
        "Our AI empowers your team to focus on prospects most likely to convert, driving revenue growth with minimal effort.",
    },
    {
      headline: "Powerful Features",
      items: [
        "Automated Lead Scoring & Prioritization",
        "Seamless CRM Integration (Salesforce, HubSpot, Zoho)",
        "Real-Time Insights & Recommendations",
        "Predictive Analytics for Conversion Probability",
        "Multi-Channel Lead Tracking (Email, Calls, Chat)",
      ],
      content:
        "Supercharge your sales efficiency with AI-powered tools trusted by teams worldwide.",
    },
    {
      headline: "Qualify Leads in Seconds",
      content:
        "Instantly analyze and score leads with our AI Sales Agent. Spend less time on low-value prospects and more time closing deals.",
      cta: "Try It Now",
      items: [],
    },
    {
      headline: "Why Businesses Trust Us",
      items: [
        "Reduce time spent on unqualified leads.",
        "Boost conversion rates with data-driven insights.",
        "Automate prioritization and follow-ups.",
        "Enhance sales team productivity.",
        "Gain insights into pipeline health and trends.",
      ],
    },
    {
      headline: "Seamless CRM Integration",
      content:
        "Integrate with Salesforce, HubSpot, Zoho, and more. Sync lead scores, track engagement, and access predictive analytics directly in your CRM.",
      cta: "Connect Your CRM",
      items: [],
    },
    {
      headline: "Trusted by Sales Teams Worldwide",
      content:
        "Join hundreds of teams using our AI Sales Agent to prioritize leads, shorten sales cycles, and boost conversions.",
      items: [],
    },
    {
      headline: "Frequently Asked Questions",
      items: [
        "Can I customize lead scoring? – Yes, tailor it to your sales process.",
        "Is my data secure? – We use industry-standard encryption.",
        "Can it handle multiple lead sources? – Yes, it consolidates all platforms.",
        "Does it suggest follow-ups? – AI provides actionable recommendations.",
      ],
    },
    {
      headline: "Simple, Transparent Pricing",
      content:
        "Choose a plan that fits your needs. Start free or upgrade for advanced AI features like unlimited lead scoring and priority support.",
      cta: "Explore Pricing",
      items: [],
    },
    {
      headline: "Start Qualifying Smarter Today",
      content:
        "Let our AI Sales Agent identify high-potential leads and streamline your sales process. Close deals faster and scale your business.",
      cta: "Get Started Now",
      items: [],
    },
  ],
};

const LeadQualification = () => {
  return (
    <div className={styles.container}>
        <div className={styles.uppercontainer}>
      <div className={styles.hero}>
        <h1 className={styles.heroTitle}>Supercharge Your Sales with AI</h1>
        <p className={styles.heroSubtitle}>
          Instantly qualify leads and focus on what matters—closing deals.
        </p>
        <button className={styles.heroCta}>Get Started Now</button>
      </div>
      <div className={styles.grid}>
        {pageData.sections.map((section, index) => (
          <div key={index} className={`${styles.card} ${styles[`card${index % 3}`]}`}>
            {section.headline && <h2 className={styles.headline}>{section.headline}</h2>}
            {section.subheadline && <p className={styles.subheadline}>{section.subheadline}</p>}
            {section.content && <p className={styles.content}>{section.content}</p>}
            {section.items && section.items.length > 0 && (
              <ul className={styles.list}>
                {section.items.map((item, i) => (
                  <li key={i} className={styles.listItem}>
                    <FaCheckCircle className={styles.listIcon} />
                    {item}
                  </li>
                ))}
              </ul>
            )}
            {section.cta && (
              <button className={styles.cta}>{section.cta}</button>
            )}
          </div>
        ))}
      </div>
      </div>
     <div className={styles.footerContainer}>
      </div>
    </div>
  );
};

export default LeadQualification;